'use strict'

import game from './game'
import dragon from './dragon'

export default { game, dragon }



// WEBPACK FOOTER //
// ./resources/assets/js/dragon/api/index.js